import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { ResponseModel } from 'common/interfaces';
import { useFetch } from 'hooks/use-fetch';
import { processErrorMessages } from 'shared/api/process-error-messages';

import type { Notification } from '../../model';
import { notificationQueryKeys } from '../query-keys';

interface UseNotificationGetListOptions
  extends Omit<
    UseQueryOptions<Notification[], unknown, Notification[], ReturnType<typeof notificationQueryKeys.lists>>,
    'queryKey' | 'queryFn'
  > {}

export const useNotificationGetList = (options?: UseNotificationGetListOptions) => {
  const { fetch } = useFetch<ResponseModel<Notification[]>>({
    isShowLoading: false,
    isShowErrorSnackbar: false
  });

  const handleGetNotifications = async () => {
    const response = await fetch({
      requestConfig: {
        method: 'POST',
        url: '/Jobs/GetMessages',
        data: {}
      }
    });

    if (!response.data.isSuccess) {
      throw new Error(processErrorMessages(response.data.messages));
    }

    return response.data.data;
  };

  return useQuery({
    queryKey: notificationQueryKeys.lists(),
    queryFn: handleGetNotifications,
    ...options
  });
};
